import React, { useState, useEffect, useContext } from "react"
import { Table, Alert, Spinner, Badge } from "react-bootstrap"
import SwaggerContext from "../SwaggerContext"
import { invitationService } from "../services/invitationService"
import SendInvitation from "./SendInvitation"

const ManageInvitations = () => {
  const [invitations, setInvitations] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const swaggerClient = useContext(SwaggerContext)

  const loadInvitations = async () => {
    try {
      setLoading(true)
      if (!swaggerClient?.invitationApi) {
        throw new Error("API no disponible")
      }

      const result = await invitationService.getSentInvitations(
        swaggerClient.invitationApi
      )

      if (result.success) {
        setInvitations(result.data || [])
        setError("")
      } else {
        const errorMsg = result.error || "Error al cargar invitaciones"
        setError(errorMsg)
      }
    } catch (err) {
      const errorMsg = err instanceof Error ? err.message : "Error desconocido"
      setError(errorMsg)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadInvitations()
  }, [swaggerClient])

  const getStatusBadge = (status) => {
    switch (status) {
      case "PENDING":
        return <Badge bg="warning">Pendiente</Badge>
      case "ACCEPTED":
        return <Badge bg="success">Aceptada</Badge>
      case "REJECTED":
        return <Badge bg="danger">Rechazada</Badge>
      case "EXPIRED":
        return <Badge bg="secondary">Expirada</Badge>
      default:
        return <Badge>{status}</Badge>
    }
  }

  if (loading && invitations.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    )
  }

  return (
    <div className="manage-invitations">
      <h2 className="mb-4">Gestión de Invitaciones</h2>

      <SendInvitation
        onSuccess={loadInvitations}
        onError={(err) => setError(err)}
      />

      {error && <Alert variant="danger" className="mb-3">{error}</Alert>}

      <div className="invitations-table">
        <h3 className="mb-3">Mis Invitaciones</h3>

        {invitations.length === 0 ? (
          <Alert variant="info">No hay invitaciones</Alert>
        ) : (
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Usuario</th>
                  <th>Estado</th>
                  <th>Enviada</th>
                  <th>Aceptada/Rechazada</th>
                </tr>
              </thead>
              <tbody>
                {invitations.map((invitation) => (
                  <tr key={invitation.id}>
                    <td>{invitation.invitedEmail}</td>
                    <td>{invitation.invitedUsername || "-"}</td>
                    <td>{getStatusBadge(invitation.status)}</td>
                    <td>
                      {new Date(invitation.invitedAt).toLocaleDateString(
                        "es-ES"
                      )}
                    </td>
                    <td>
                      {invitation.acceptedAt
                        ? new Date(invitation.acceptedAt).toLocaleDateString(
                            "es-ES"
                          )
                        : invitation.rejectedAt
                        ? new Date(invitation.rejectedAt).toLocaleDateString(
                            "es-ES"
                          )
                        : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </div>
  )
}

export default ManageInvitations
